import { render, staticRenderFns } from "./regularDetail.vue?vue&type=template&id=96adfcf8&scoped=true&"
import script from "./regularDetail.vue?vue&type=script&lang=js&"
export * from "./regularDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96adfcf8",
  null
  
)

export default component.exports